export default "__VITE_ASSET__cdd4d443__"